import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { DocumentLinkWrapper } from "./Component"

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		DocumentLinkNode: {
			setDocumentLink: (args: { uuid: string }) => ReturnType
		}
	}
}

export const DocumentLinkNode = Node.create({
	name: "DocumentLinkNode",
	group: "block",
	selectable: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	addCommands() {
		return {
			setDocumentLink:
				({ uuid }) =>
				({ chain }) => {
					return chain()
						.focus()
						.insertContent({
							type: this.type.name,
							attrs: { uuid: uuid },
						})
						.run()
				},
		}
	},
	parseHTML() {
		return [
			{
				tag: "document-link",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["document-link", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(DocumentLinkWrapper)
	},
})
